import { setItem } from '@ms/yammer-session-storage';
import { isSameSiteNoneCompatible } from 'should-send-same-site-none';

import type { CookieOptions } from './cookies';
import { remove, set } from './cookies';

export const thirdPartyCookieBlockedKey = 'Yammer.ThirdPartyCookieBlocked';
export const testCookieName = 'cookietest';
export const testCookieValue = '1';
export const defaultOptions: CookieOptions = { partitioned: false };

type CheckThirdPartyCookieSupport = () => boolean;
export const checkThirdPartyCookieSupport: CheckThirdPartyCookieSupport = () => {
  const cookieOptions: CookieOptions = isSameSiteNoneCompatible(navigator.userAgent)
    ? { ...defaultOptions, sameSite: 'none' }
    : defaultOptions;

  try {
    set(testCookieName, testCookieValue, cookieOptions);
    remove(testCookieName, cookieOptions);
    setItem(thirdPartyCookieBlockedKey, false);

    return true;
  } catch {
    setItem(thirdPartyCookieBlockedKey, true);

    return false;
  }
};
